import type { TradePlanRegimeDto } from '../../lib/api/endpoints';
import { cn } from '../../lib/utils';

interface TradePlanRegimeBannerProps {
  regime: TradePlanRegimeDto | null;
}

export function TradePlanRegimeBanner({ regime }: TradePlanRegimeBannerProps) {
  if (!regime) {
    return (
      <section className="rounded border border-border bg-surface px-4 py-3 text-sm text-text-muted">
        Regime status will appear when the first valid plan inputs are entered.
      </section>
    );
  }
  const nextTier =
    regime.nextTierAt === null
      ? 'Full risk tier unlocked'
      : `${regime.cleanExecutionCount}/${regime.nextTierAt} clean executions to next tier`;
  return (
    <section
      className={cn(
        'rounded border px-4 py-3',
        regime.mode === 'DEFENSIVE'
          ? 'border-danger/50 bg-danger/10'
          : 'border-success/40 bg-success/10',
      )}
      aria-label="Current trading regime"
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <strong>{regime.mode}</strong>
        <span className="text-sm">
          Risk tier {(regime.riskTierPct * 100).toFixed(1)}% · {nextTier}
        </span>
      </div>
      <p className="mt-1 text-sm text-text-muted">
        {regime.qqqPrice === null || regime.qqqSma50 === null
          ? 'QQQ 50DMA data unavailable'
          : `QQQ ${regime.qqqPrice.toFixed(2)} vs 50DMA ${regime.qqqSma50.toFixed(2)} as of ${regime.qqqAsOfDate ?? 'unknown'}`}
      </p>
    </section>
  );
}
